{
  "login": {
    "title": "Willkommen zurück",
    "subtitle": "Melden Sie sich an, um fortzufahren",
    "emailTab": "E-Mail & Passwort",
    "smsTab": "SMS",
    "emailLabel": "E-Mail",
    "emailPlaceholder": "E-Mail",
    "emailRequired": "Bitte geben Sie Ihre E-Mail ein!",
    "emailInvalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein!",
    "passwordLabel": "Passwort",
    "passwordPlaceholder": "Passwort",
    "passwordRequired": "Bitte geben Sie Ihr Passwort ein!",
    "loginButton": "Anmelden",
    "loginWithGoogle": "Mit Google anmelden",
    "noAccount": "Noch kein Konto?",
    "signUp": "Registrieren",
    "registerNow": "Jetzt registrieren",
    "loginFailed": "Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "googleLoginFailed": "Google-Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "loginWithCas": "Mit Firmenkonto anmelden (CAS)",
    "casLoginFailed": "Die Firmenanmeldung ist fehlgeschlagen oder Ihr Konto hat keinen Zugriff. Bitte versuchen Sie es erneut oder nutzen Sie eine andere Anmeldemethode.",
    "casCompleting": "Anmeldung wird abgeschlossen…",
    "phoneLabel": "Telefonnummer",
    "phonePlaceholder": "Telefonnummer",
    "phoneRequired": "Bitte geben Sie Ihre Telefonnummer ein!",
    "codeLabel": "Bestätigungscode",
    "codePlaceholder": "Code",
    "codeRequired": "Bitte geben Sie den Code ein!",
    "sendCode": "Code senden",
    "resendCode": "Code erneut senden",
    "codeSent": "Ein Bestätigungscode wurde an Ihr Telefon gesendet.",
    "phoneInvalid": "Bitte geben Sie eine gültige Telefonnummer ein.",
    "invalidCode": "Ungültiger Bestätigungscode.",
    "codeExpired": "Bestätigungscode nicht gefunden oder abgelaufen. Bitte fordern Sie einen neuen an.",
    "phoneNotRegistered": "Telefonnummer nicht registriert oder nicht bestätigt.",
    "codeSendFailed": "Code konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
    "codeVerifyFailed": "Anmeldung fehlgeschlagen. Bitte überprüfen Sie den Code und versuchen Sie es erneut.",
    "forgotPassword": "Passwort vergessen?",
    "emailNotVerified": "Bitte bestätigen Sie Ihre E-Mail, bevor Sie sich anmelden.",
    "resendVerification": "Bestätigungs-E-Mail erneut senden",
    "resendVerificationSuccess": "Falls ein unbestätigtes Konto existiert, wurde eine Bestätigungs-E-Mail gesendet.",
    "fixErrors": "Bitte beheben Sie die Fehler unten."
  },
  "register": {
    "title": "Konto erstellen",
    "subtitle": "Starten Sie mit SmartAss AI",
    "haveAccount": "Bereits ein Konto?",
    "signIn": "Anmelden",
    "failed": "Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "fixErrors": "Bitte beheben Sie die Fehler unten.",
    "emailExists": "Ein Benutzer mit dieser E-Mail existiert bereits.",
    "phoneExists": "Diese Telefonnummer wird bereits von einem anderen Konto verwendet. Verwenden Sie eine andere Nummer oder lassen Sie das Feld leer.",
    "inviteInvalid": "Einladungslink ist ungültig oder abgelaufen.",
    "nameLabel": "Vollständiger Name",
    "namePlaceholder": "Vollständiger Name",
    "nameRequired": "Bitte geben Sie Ihren vollständigen Namen ein!",
    "emailLabel": "E-Mail",
    "emailPlaceholder": "E-Mail",
    "emailRequired": "Bitte geben Sie Ihre E-Mail ein!",
    "emailInvalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein!",
    "phoneLabel": "Telefonnummer",
    "phonePlaceholder": "+49 123 4567890",
    "passwordLabel": "Passwort",
    "passwordPlaceholder": "Passwort",
    "passwordRequired": "Bitte geben Sie Ihr Passwort ein!",
    "passwordMin": "Das Passwort muss mindestens 8 Zeichen lang sein!",
    "passwordPattern": "Das Passwort muss Groß-, Kleinbuchstaben, Zahl und Sonderzeichen (@$!%*?&) enthalten",
    "confirmPasswordLabel": "Passwort bestätigen",
    "confirmPasswordPlaceholder": "Passwort bestätigen",
    "confirmPasswordRequired": "Bitte bestätigen Sie Ihr Passwort!",
    "passwordMismatch": "Die Passwörter stimmen nicht überein!",
    "submit": "Registrieren",
    "alreadyHaveAccountDivider": "Bereits ein Konto?",
    "logIn": "Anmelden",
    "checkEmailTitle": "E-Mail prüfen",
    "checkEmailMessage": "Wir haben Ihnen einen Bestätigungslink gesendet. Bitte bestätigen Sie Ihre E-Mail vor der Anmeldung.",
    "resendVerification": "Bestätigungs-E-Mail erneut senden",
    "resendVerificationSuccess": "Falls ein unbestätigtes Konto existiert, wurde eine Bestätigungs-E-Mail gesendet.",
    "tenantInviteTitle": "Team-Einladung",
    "tenantInviteDescription": "Sie wurden eingeladen, einem Team beizutreten. Schließen Sie die Registrierung ab, um die Einladung anzunehmen."
  },
  "forgotPassword": {
    "title": "Passwort vergessen",
    "subtitle": "Geben Sie Ihre E-Mail ein und wir senden Ihnen einen Link zum Zurücksetzen",
    "emailLabel": "E-Mail",
    "emailPlaceholder": "E-Mail",
    "emailRequired": "Bitte geben Sie Ihre E-Mail ein!",
    "emailInvalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein!",
    "submit": "Link senden",
    "successMessage": "Falls ein Konto existiert, wurde ein Link zum Zurücksetzen gesendet.",
    "backToLogin": "Zurück zur Anmeldung",
    "failed": "Link konnte nicht gesendet werden. Bitte versuchen Sie es erneut."
  },
  "resetPassword": {
    "title": "Passwort zurücksetzen",
    "subtitle": "Wählen Sie ein neues Passwort für Ihr Konto",
    "passwordLabel": "Neues Passwort",
    "passwordPlaceholder": "Neues Passwort",
    "passwordRequired": "Bitte geben Sie Ihr neues Passwort ein!",
    "confirmPasswordLabel": "Neues Passwort bestätigen",
    "confirmPasswordPlaceholder": "Neues Passwort bestätigen",
    "confirmPasswordRequired": "Bitte bestätigen Sie Ihr neues Passwort!",
    "submit": "Passwort zurücksetzen",
    "success": "Passwort erfolgreich aktualisiert. Sie können sich jetzt anmelden.",
    "failed": "Passwort konnte nicht zurückgesetzt werden. Bitte versuchen Sie es erneut.",
    "invalidToken": "Dieser Link ist ungültig oder abgelaufen."
  },
  "verifyEmail": {
    "title": "E-Mail bestätigen",
    "verifying": "E-Mail wird bestätigt...",
    "success": "Ihre E-Mail wurde bestätigt. Sie können sich jetzt anmelden.",
    "successSignedIn": "Ihre E-Mail wurde bestätigt.",
    "failed": "E-Mail konnte nicht bestätigt werden. Bitte versuchen Sie es erneut.",
    "invalidToken": "Dieser Bestätigungslink ist ungültig oder abgelaufen.",
    "backToLogin": "Zurück zur Anmeldung",
    "backToProfile": "Zurück zum Profil"
  },
  "verifyLead": {
    "title": "Kontaktdaten bestätigen",
    "verifying": "Kontaktdaten werden bestätigt...",
    "success": "Ihre Kontaktdaten wurden bestätigt.",
    "failed": "Kontaktdaten konnten nicht bestätigt werden. Der Link ist möglicherweise abgelaufen oder bereits verwendet.",
    "invalidToken": "Dieser Bestätigungslink ist ungültig oder abgelaufen.",
    "enterCode": "Geben Sie den 6-stelligen Code ein, den wir an Ihr Telefon gesendet haben.",
    "codeRequired": "Bitte geben Sie den 6-stelligen Code ein.",
    "invalidCode": "Dieser Code ist ungültig. Bitte versuchen Sie es erneut.",
    "submitCode": "Bestätigen",
    "backToLogin": "Zurück zur Anmeldung"
  },
  "videoMeeting": {
    "loading": "Besprechung wird geladen…",
    "notFoundTitle": "Besprechung nicht gefunden",
    "notFoundDescription": "Die angeforderte Videobesprechung wurde nicht gefunden oder ist abgelaufen."
  }
}
